import DatetimePicker from "componentsv2/form/DatetimePicker";
import DatePicker from "componentsv2/form/DatePicker";
import DateCalendar from "componentsv2/form/DateCalendar";
import TimePicker from "componentsv2/form/TimePicker";

import Checkbox from "componentsv2/form/Checkbox";
import Dropdown from "componentsv2/form/Dropdown";
import Numeric from "componentsv2/form/Numeric";
import Integer from "componentsv2/form/Integer";
import Selection from "componentsv2/form/Selection";
import Float from "componentsv2/form/Float";
import Char from "componentsv2/form/Char";
import Heading from "componentsv2/form/Heading";
import Text from "componentsv2/form/Text";
import GridFields from "componentsv2/form/GridFields";
import ButtonForm from "componentsv2/button/ButtonForm";
import ButtonCheck from "componentsv2/button/ButtonCheck";
import ModalCards from "componentsv2/modal/ModalCards";
import BoardTable from "componentsv2/table/BoardTable";
import BoardCards from "componentsv2/card/BoardCards";
import SearchField from "componentsv2/form/SearchField";
import ModalTab from "componentsv2/modal/ModalTab";
import ModalWizard from "componentsv2/modal/ModalWizard";
import CustomComponentField from "componentsv2/experimental/CustomComponentField";

const pool = () => ({
  char: Char,
  text: Text,
  date: DatePicker,
  date_2: DateCalendar,
  time: TimePicker,
  datetime: DatetimePicker,
  selection: Selection,
  many2one: Dropdown,
  boolean: Checkbox,
  float: Float,
  integer: Integer,
  numeric: Numeric,
  grid: GridFields,
  button: ButtonForm,
  modal_cards: ModalCards,
  cards: BoardCards,
  one2many: BoardTable,
  heading: Heading,
  custom_component: CustomComponentField,
  search: SearchField,
  button_check: ButtonCheck,
  button_tab: ModalTab,
  button_wizard: ModalWizard,
  // char_inline: CharInlineField,
  // selection_card: SelectionCardField,
  // multiselection: MultiSelectionField,
  // float: FloatField,
  // search_add: SearchField,
  // radio: RadioGroupField,
  // image: ImageField,
  // cloud_image: CloudImage,
  // button_icon: ButtonIcon,
  // button_check: ButtonCheck,
  // take_capture: TakeCapture,
  // file: FileField,
  // divider: DividerField,
  // button_custom_modal: ButtonCustomModal,
  // paragraph: Paragraph,
  // custom: CustomWidget,
  // heading: Heading,
  // cards: GridCards,
  // time: TimeField,
});

export default pool;
